/* eslint-disable @typescript-eslint/no-misused-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { chirpEnumToString } from 'academy-common-lib/utils/chirp';
import { stringify } from 'hub-http/helpers/params';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { VideoPlayIcon } from 'foundations-assets/icons/components/VideoPlayIcon';
import UsageTracker from '../../../../utils/UsageTracker';
import { useRequestLearnWhileDoing } from '../../hooks';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from '../../../../constants/Navigation';
import useNavigate from '../../../../hooks/useNavigate';
import { useFullShort } from '../../../shortContent/shortContentQueries';
import { useLocation } from 'quartz-routing/react-router';

// Button that navigates to software recommendations with learn-while-doing mode
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LearnWhileDoingButton = ({
  otgId
}) => {
  const {
    isVideoFinished,
    isVideoPlayed
  } = useRequestLearnWhileDoing();
  const {
    short
  } = useFullShort(Number(otgId), !otgId);
  const videoType = chirpEnumToString(short === null || short === void 0 ? void 0 : short.shortFormContentType);
  const visibility = chirpEnumToString(short === null || short === void 0 ? void 0 : short.visibility);
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const learnByDoingOnClick = () => {
    UsageTracker.trackStandalone('Content Interaction', {
      action: 'learn-by-doing-cta-play-in-software-clicked',
      shortId: String(otgId),
      contentId: String(otgId),
      videoType,
      visibility
    });
    const currentSearchParams = new URLSearchParams(currentLocation.search);
    currentSearchParams.delete('backLocation');
    const cleanSearch = currentSearchParams.toString() ? `?${currentSearchParams.toString()}` : '';
    const backLocation = `${currentLocation.pathname}${cleanSearch}`;
    navigate(location => Object.assign({}, location, {
      search: `?${stringify({
        otgId,
        isLearnWhileDoing: true,
        backLocation
      })}`,
      pathname: `/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}`
    }));
  };
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-brand-default",
    borderRadius: "full",
    children: /*#__PURE__*/_jsx(Button, {
      block: true,
      borderColor: "border-core-on-fill-default",
      borderRadius: "full",
      borderWidth: "100",
      "data-test-id": "learn-while-doing-button",
      onClick: learnByDoingOnClick,
      paddingBlock: "400",
      size: "medium",
      use: "transparent",
      children: /*#__PURE__*/_jsxs(View, {
        inlineSize: "100%",
        position: "relative",
        children: [/*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          blockSize: "100%",
          insetBlockStart: "0",
          insetInlineStart: "-100",
          position: "absolute",
          children: /*#__PURE__*/_jsx(View, {
            backgroundColor: "fill-surface-default",
            blockSize: "40px",
            borderRadius: "full",
            inlineSize: "40px"
          })
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          blockSize: "100%",
          insetBlockStart: "0",
          insetInlineStart: "-200",
          position: "absolute",
          children: /*#__PURE__*/_jsx(VideoPlayIcon, {
            color: "fill-brand-default",
            size: "900"
          })
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          justifyContent: "center",
          paddingInlineStart: "600",
          children: /*#__PURE__*/_jsx(Text, {
            as: "strong",
            color: "text-core-on-fill-default",
            children: !isVideoFinished && isVideoPlayed ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.learnByDoing.continueInsideHubSpotSoftware"
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.learnByDoing.watchInAccount"
            })
          })
        })]
      })
    })
  });
};
export default LearnWhileDoingButton;